import React from 'react';
import Container from 'react-bootstrap/Container';
import SiteShutdownsDataGrid from '../../components/DataGrids/SiteShutdownsDataGrid';

const styles = {
    siteShutdownsNote: {
        fontWeight: '400',
        fontSize: '14px'
    }
};

const SiteShutdowns: React.FunctionComponent = () => {
    return (
        <Container fluid className='ml-2'>
            <div style={{ display: 'flex', flexDirection: 'row' }} className='ml-n3 my-2 container-fluid'>
                <p className='incidentHistoryMessage' style={styles.siteShutdownsNote}>
                    Note: The data presented here is sourced from PreCog. Please note that not all business
                    lines or regions may be included in this dataset.
                </p>
            </div>
            <div className='container-fluid pr-5'>
                <SiteShutdownsDataGrid />
            </div>
        </Container>
    );
};

export default SiteShutdowns;
